export default "__VITE_ASSET__dRAo6wQu__"